/* RS: sugestões da barra de busca do topo (25/09/2026).
   Desliga o autocomplete nativo do tema (predictive-search do GearX, que consulta
   /search/suggest.json) e mostra as sugestões do motor da casa, o mesmo da página de
   resultados: casa pedaço de código (2933 acha RS2933), código original equivalente e
   aplicação de veículo da planilha da RS. */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LIM = 8;

  function brl(v) {
    return 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function img(src) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }

  /* o painel vive no body e é ancorado ao campo: o form do header tem overflow:hidden,
     que cortava um painel filho */
  function painel(form) {
    if (form.rsPainel) return form.rsPainel;
    var el = document.createElement('div');
    el.className = 'rs-sug';
    el.setAttribute('hidden', '');
    document.body.appendChild(el);
    form.rsPainel = el;
    return el;
  }
  function ancorar(el, form) {
    var r = form.getBoundingClientRect();
    el.style.left = Math.round(r.left) + 'px';
    el.style.top = Math.round(r.bottom + 6) + 'px';
    el.style.width = Math.round(r.width) + 'px';
  }
  /* o campo se move enquanto o painel está aberto (gaveta do menu abrindo, rolagem,
     header que encolhe), então acompanha em vez de ancorar uma vez só */
  function acompanhar(el, form) {
    if (el.rsSeguindo) return;
    el.rsSeguindo = true;
    (function passo() {
      if (el.hasAttribute('hidden')) { el.rsSeguindo = false; return; }
      ancorar(el, form);
      requestAnimationFrame(passo);
    })();
  }
  function mostrar(el, form) { ancorar(el, form); el.removeAttribute('hidden'); acompanhar(el, form); }

  function desenhar(el, form, lista, total, termo) {
    if (!lista.length) {
      el.innerHTML = '<div class="rs-sug__vazio">Nada encontrado para "' + esc(termo) + '". Tente o código do filtro ou o modelo do veículo.</div>';
      mostrar(el, form);
      return;
    }
    var h = lista.map(function (c) {
      return '<a class="rs-sug__i" href="' + raiz + 'products/' + esc(c.h) + '">' +
        '<span class="rs-sug__t">' + (c.img ? '<img loading="lazy" src="' + esc(img(c.img)) + '" alt="">' : '') + '</span>' +
        '<span class="rs-sug__n">' + esc(c.t) + '</span>' +
        '<span class="rs-sug__p">' + brl(c.p) + '</span></a>';
    }).join('');
    if (total > lista.length) {
      h += '<a class="rs-sug__todos" href="' + raiz + 'search?q=' + encodeURIComponent(termo) + '">Ver todos os ' + total + ' resultados</a>';
    }
    el.innerHTML = h;
    mostrar(el, form);
  }

  function ligar(input) {
    if (input.dataset.rsLigado) return;
    input.dataset.rsLigado = '1';
    var form = input.closest('form');
    if (!form) return;
    var el = painel(form), tmr = null;
    var nativo = !!input.closest('predictive-search');

    function rodar() {
      var v = (input.value || '').trim();
      if (v.length < 2) { el.setAttribute('hidden', ''); el.innerHTML = ''; return; }
      el.innerHTML = '<div class="rs-sug__vazio">Procurando…</div>';
      mostrar(el, form);
      window.RSMotor.buscar(v).then(function (r) {
        if ((input.value || '').trim() !== v) return; /* já digitou outra coisa */
        desenhar(el, form, r.slice(0, LIM), r.length, v);
      }).catch(function () { el.setAttribute('hidden', ''); });
    }

    /* em capture, para chegar antes do autocomplete nativo do tema (custom element
       predictive-search do GearX); onde ele não existe, é só um listener comum */
    input.addEventListener('input', function (e) {
      if (nativo) e.stopImmediatePropagation();
      clearTimeout(tmr);
      tmr = setTimeout(rodar, 180);
      if ((input.value || '').trim().length >= 2) window.RSMotor.carregar().catch(function () {});
    }, true);
    input.addEventListener('focus', function (e) {
      if (nativo) e.stopImmediatePropagation();
      window.RSMotor.carregar().catch(function () {});
    }, true);
    if (nativo) {
      input.addEventListener('keyup', function (e) { e.stopImmediatePropagation(); }, true);
    }
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { el.setAttribute('hidden', ''); } });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !el.contains(e.target)) el.setAttribute('hidden', '');
    });
    /* o painel é fixo: acompanha rolagem e mudança de tamanho da janela */
    ['scroll', 'resize'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (!el.hasAttribute('hidden')) ancorar(el, form); }, { passive: true });
    });
  }

  function varrer() {
    document.querySelectorAll('form[action*="search"] input[name="q"]').forEach(ligar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
  /* o header é redesenhado em algumas telas (menu mobile, editor de tema) */
  var agendado = null;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = setTimeout(function () { agendado = null; varrer(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
